import { useLang } from "../i18n/LanguageContext";
import { MapPin, Languages, ShieldCheck, Clock } from "lucide-react";

const ICONS = { mapPin: MapPin, languages: Languages, shieldCheck: ShieldCheck };
const TECH_IMG = "https://images.unsplash.com/photo-1705579604902-eb832f58bf85?w=1200&q=80&auto=format&fit=crop";

export const Advantage = () => {
  const { t } = useLang();
  return (
    <section id="advantage" data-testid="advantage-section" className="relative py-24 md:py-32 bg-ink-deep">
      <div className="absolute inset-x-0 top-0 divider-temp" />
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-start">
          {/* Left visual block */}
          <div className="lg:col-span-5">
            <div className="relative rounded-3xl overflow-hidden border border-white/10 aspect-[4/5]">
              <img src={TECH_IMG} alt="Aarón technician" className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/30 to-transparent" />
              <div className="absolute bottom-5 left-5 right-5 flex items-center gap-3 rounded-2xl bg-ink-card/85 backdrop-blur p-4 border border-white/10" data-testid="response-promise-badge">
                <div className="h-12 w-12 rounded-xl bg-heat/20 ring-1 ring-heat/40 flex items-center justify-center animate-pulse-glow">
                  <Clock className="text-heat" size={22} />
                </div>
                <div>
                  <div className="text-[10px] uppercase tracking-[0.2em] text-heat font-bold">30 min</div>
                  <div className="text-sm text-white/85 leading-snug">{t.advantage.promiseBadge}</div>
                </div>
              </div>
            </div>
          </div>

          {/* Right content */}
          <div className="lg:col-span-7">
            <span className="text-xs font-semibold uppercase tracking-[0.22em] text-cool">{t.advantage.eyebrow}</span>
            <h2 className="mt-4 font-heading font-bold text-white tracking-tight text-4xl sm:text-5xl leading-[1.05]" data-testid="advantage-title">
              {t.advantage.title}
            </h2>

            <div className="mt-10 grid sm:grid-cols-1 gap-4">
              {t.advantage.items.map((item, i) => {
                const Icon = ICONS[item.icon] || ShieldCheck;
                const isOdd = i % 2 === 1;
                return (
                  <div
                    key={item.title}
                    data-testid={`advantage-item-${i}`}
                    className={`flex gap-5 rounded-2xl border border-white/10 bg-ink-card/60 p-6 hover:bg-ink-card transition ${isOdd ? "card-warm" : "card-cool"}`}
                  >
                    <div className={`shrink-0 h-14 w-14 rounded-2xl flex items-center justify-center ${isOdd ? "bg-heat/10 ring-1 ring-heat/30 text-heat" : "bg-cool/10 ring-1 ring-cool/30 text-cool"}`}>
                      <Icon size={24} />
                    </div>
                    <div>
                      <h3 className="font-heading font-bold text-white text-xl sm:text-2xl tracking-tight">{item.title}</h3>
                      <p className="mt-1 text-sm text-white/65 leading-relaxed">{item.desc}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
